export default class priceHandler{
    static formatPrice( price: number) {
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( price )
    }

    static getCouponEuroValue(couponH: any, totalPrice: any, duration: number) {
        if( couponH == 0 ) return 0;

        const pricePerHour = totalPrice / duration;
        const couponHourDiff = couponH - duration;
        if( couponHourDiff >= 0 ) {
            return totalPrice;
        } else {
            return ( pricePerHour * (duration - couponH ) );
        }
    }

    static calculatePriceTotal( priceLineItems: any, vatInPercent = 19, format = 'total', formater: any = priceHandler.formatPrice): any {
        console.log( '### Start Calculate Price ###');
        if( priceLineItems ){
            const total: number = priceLineItems.reduce( (a:number, b:any) => {
                console.log( "Run Price :", a );
                if( b.type == "coupon" && b.unit == "%" ){
                    console.log( b );
                    return a + ( a * ( b.value / 100 ) );
                } else 
                    return a + b.price;
            }, 0)
    
            // Add 19% VAT
            if( vatInPercent > 0 ){
                switch( format ){
                    case 'total':
                        return  formater( total * (1 + 0.01 * vatInPercent) );
                    case 'vatOnly':
                        return formater( total * ( 0.01 * vatInPercent) );
                    case 'noVat':
                        return formater( total );
                    default:
                        return formater( total * (1 + 0.01 * vatInPercent) );
                }
            } else {
                switch( format ){
                    case 'total':
                        return formater( total );
                    case 'vatOnly':
                        return formater( 0 );
                    case 'noVat':
                            return formater( total );
                    default:
                        return formater( total );
                }
            }
            
        }
        return 0;
    }


    static addBigGroups( inArry: [any], bookingType: any, formfieldPerson: number, duration: number) {

        /* Vermutlich für Gewerblichen Große Gruppen aufschlag */
        const out = inArry;
        
        let personAdd = 0;
        const maxPersons = bookingType.maxPersons;
        const persons = bookingType.persons;

        if( persons && persons.addCost ){
            Object.keys(persons.addCost).forEach( (value ) => {
                if( parseInt( value ) <= formfieldPerson ){
                    personAdd = persons.addCost[ value ];
                }
            });
        }

        if( personAdd > 0 ){
            out.push({
                description: 'Zuschlag große Gruppe',
                price: personAdd * ( Math.round( duration/24) > 0 ? Math.round( duration/24) : 1 )
            });
        }

        return out;
    }

    static addBigGroupsNew( inArry: [any], bookingType: any, formfieldPerson: number, duration: number, typ: string, formfieldActivePerson: number) {
        const out = inArry;
        
        const additonalPerson = formfieldPerson - 6 - ( formfieldActivePerson - 2 >= 0 ? formfieldActivePerson - 2 : 0 );
        if( formfieldPerson >= 7 && typ == "Privat" && additonalPerson > 0 ){
            out.push({
                description: `Zuschlag für große Gruppen pro Person (${ additonalPerson })`,
                price: 10 * additonalPerson * duration
            });
        }     

        return out;
    }

    static addMoreActivePeople( inArry: [any], formfieldTyp: string, formfieldActivePerson: number,  formfieldDuration: number){
        const out = inArry;

        if( formfieldActivePerson >= 3 && formfieldTyp == "Privat" ){
            out.push({
                description: `Zuschlag für mehr als 2 Fotografen/Videografen pro Stunde (${ formfieldActivePerson - 2})`,
                price: 25 * ( formfieldActivePerson - 2 ) /* this.formfieldDuration */
            });
        }

        return out;
    }

    static addCoupon( inArry: [any], coupon: any, price: number, duration: number){

        const out = inArry;

        if( coupon.unit == "%" ){
            out.push({
                type: "coupon",
                description: `Coupon ${ coupon.code } ( ${ coupon.value }${coupon.unit} )`,
                value: coupon.value, 
                unit: coupon.unit
            })
        } else if( coupon.unit == "h" ){
            out.push({
                type: "coupon",
                description: `Coupon ${ coupon.code } (Reststunden: ${ coupon.price })`,
                price: -( priceHandler.getCouponEuroValue( coupon.price, price, duration ) ),
                unit: "€"
            })
        } else {
            out.push({
                type: "coupon",
                description: `Coupon ${ coupon.code }`,
                price: coupon.price,
                unit: coupon.unit
            })
        }

        return out;
    }
}
